import { render, staticRenderFns } from "./AddEditMember.vue?vue&type=template&id=72933a57&"
import script from "./AddEditMember.vue?vue&type=script&lang=ts&"
export * from "./AddEditMember.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddEditMember.vue"
export default component.exports